import { CardExpiryElement } from '@stripe/react-stripe-js'
import createInput from './utils'

const CardExpiryInput = createInput(CardExpiryElement)
export default CardExpiryInput
